/* Actions */
export const GET_REQUEST = "GET_REQUEST";

/* Mutations */
export const GET_REQUEST_SUCCESS = "GET_REQUEST_SUCCESS";
